<!-- 工程师列表 -->
<template>
  <div class="engineer-list">
    <BaseEmpty 
      v-if="options.length === 0"
      text="还没有工程师信息" 
      btnText="+新增一个" 
      :isError="isError"
      @btnClick="handleAdd" 
    />
    <template v-else>
      <RadioTable2
        v-model="val"
        radioKey="id"
        radioLabel="#"
        :height="200"
        :showExpand="true"
        :isError="isError"
        :loading="loading"
        :columns="columns"
        :tableData="options"
        @change="handleChange"
      ></RadioTable2>

      <div v-if="canAdd" class="engineer-list__add">
        <BaseTextButton :plain="false" :light="true" @click="handleAdd">
          <i class="el-icon-circle-plus-outline" />
          新增
        </BaseTextButton>
      </div>
    </template>
    <AddDialog ref="addDialogRef" :showAddBtn="false" @success="handleSuccess" />
  </div>
</template>

<script>
import RadioTable2 from '@@/components/radioTable/index2'
import AddDialog from './addDialog'

export default {
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    canAdd: {
      type: Boolean,
      default: true
    },
    isError: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RadioTable2,
    AddDialog
  },
  data() {
    return {
      loading: false,
      val: this.value,
      columns: [
        { label: '姓名', prop: 'name', minWidth: 40 },
        { label: '手机/电话', prop: 'tel', minWidth: 60 },
        { label: 'E-mail', prop: 'email', minWidth: 80 }
      ],
      options: [],
      optionsLength: 0
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
    length(newVal) {
      this.optionsLength = newVal
      this.getList()
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
    },
    handleChange(item) {
      this.val = item.id || ''
      this.handleEmit()
      this.$emit('change', item)
    },
    getList() {
      this.loading = true
      this.$store.dispatch('orderEngineer/getEngineerList', this.optionsLength !== this.options.length)
        .then(res => {
          this.options = res
          this.handleLengthChange(res.length)
          this.selectDefault()
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 已选的 > 默认的 > 第一个
    selectDefault() {
      const { val, options } = this
      if (options && options.length > 0) {
        const item = options.find(i => (!!val > 0 ? i.id === val : i.isDef == 1))
        this.handleChange(item || options[0])
      } else {
        this.handleChange({})
      }
    },
    handleSuccess(id) {
      this.val = id
      this.handleLengthChange(this.optionsLength + 1)
      this.getList()
      this.$nextTick(() => {
        this.$emit('addSuccess')
      })
    },
    handleLengthChange(length) {
      this.optionsLength = length
      this.$emit('update:length', length)
    },
    // 新增
    handleAdd() {
      this.$refs.addDialogRef && this.$refs.addDialogRef.open()
    }
  }
}
</script>

<style lang="scss" scoped>
.engineer-list {
  position: relative;
  .engineer-list__add {
    position: absolute;
    top: 0;
    right: -74px;
    &::before {
      content: '';
      position: absolute;
      left: -12px;
      top: 50%;
      display: block;
      width: 12px;
      height: 1px;
      background-color: #E1E1E1;
    }
  }
}
</style>